module.exports = __webpack_public_path__ + "img/icon_Windows-Store.52444042.png";